import {
  CompassCardComponent,
  CompassCardComponentProps,
} from 'react-scale/corp/views/DataCompassV2/types';
import useUpdateReferralRatesCard from './useUpdateReferralRatesCard';
import {
  Icon,
  Switch,
  TextField,
  Heading,
  Text,
  Flex,
  Tooltip,
  Strong,
} from '@scale/scaleui-radix';
import { DatePicker } from '@scale/scaleui';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import MultiSelect from 'corp/components/UI/Select';
import pluralize from 'pluralize';

const UpdateReferralRatesCard: CompassCardComponent = ({ index }: CompassCardComponentProps) => {
  const {
    minExpireDate,
    maxExpireDate,
    selectedColumnIdWithWorkerIds,
    setSelectedColumnIdWithWorkerIds,
    setRateAmountDollars,
    isValidRateInput,
    expireDate,
    setExpireDate,
    sendComms,
    setSendComms,
    availableColumns,
    numWorkers,
  } = useUpdateReferralRatesCard(index);

  return (
    <Flex direction="column" gap="4">
      <Heading size="3">
        <Strong>Update the referral personal rates for all selected contributors.</Strong>
      </Heading>
      <Text size="2">
        This card cannot be used again in the same workflow. Please start a new workflow to run
        additional referral rate updates.
      </Text>
      <Flex direction="column" gap="4" width="full">
        <Flex direction="column" gap="2">
          {numWorkers > 0 && (
            <Text size="2">
              Selected column has {numWorkers > 1000 ? '1000+' : numWorkers}{' '}
              {pluralize('worker', numWorkers)} whose referral rates will be updated.
            </Text>
          )}
          <MultiSelect
            className="w-60 rounded-lg"
            multi={false}
            options={availableColumns.map(column => ({
              value: column.id ?? '-',
              label: column.header ?? '-',
            }))}
            disabled={false}
            placeholder="Select a column with worker ids"
            isSearchable={true}
            isClearable={true}
            value={selectedColumnIdWithWorkerIds}
            onChange={(e: any) => {
              setSelectedColumnIdWithWorkerIds(e?.value || null);
            }}
          />
        </Flex>
        <Flex direction="column" gap="2">
          <Text>Rate Amount {'(USD, $)'}</Text>
          <TextField.Root
            className="w-[200px]"
            placeholder="0"
            onChange={e => {
              setRateAmountDollars(e.target.value);
            }}
          />
          {!isValidRateInput && (
            <Text className="text-danger-500 w-[200px] pt-1">
              Please enter a valid number between 0 and 500
            </Text>
          )}
        </Flex>
        <Flex direction="column" gap="2">
          <Text>Rate Expiration Date</Text>
          <DatePicker
            value={new Date(expireDate)}
            onChange={setExpireDate}
            minDate={minExpireDate}
            maxDate={maxExpireDate}
          />
        </Flex>
        <Flex align="center" gap="2">
          <Switch size="3" checked={sendComms} onCheckedChange={setSendComms} />
          <Text size="2">Send Email Notifications</Text>
          <Tooltip content="Notify the user that their referral personal rate was increased.">
            <Icon size="1" color="neutral" label="info_circle" icon={faInfoCircle} />
          </Tooltip>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default UpdateReferralRatesCard;
